import { formatCurrency } from './formatters';

/** True when the listing price has been reduced from the original ask. */
export function hasPriceReduction(property) {
  if (!property?.asking_price || !property?.original_asking_price) return false;
  return property.asking_price < property.original_asking_price;
}

export function priceReductionAmount(property) {
  if (!hasPriceReduction(property)) return 0;
  return property.original_asking_price - property.asking_price;
}

export function formatPriceReduction(property) {
  if (!hasPriceReduction(property)) return null;
  const saved = priceReductionAmount(property);
  return `Reduced from ${formatCurrency(property.original_asking_price)} (−${formatCurrency(saved)})`;
}
